const fontWeightOption = Object.freeze({
  BOLD: 700,
  LIGHT: 300,
  MEDIUM: 500,
  REGULAR: 400,
});

const fontStyleOption = Object.freeze({
  INHERIT: 'inherit',
  INITIAL: 'initial',
  ITALIC: 'italic',
  NORMAL: 'normal',
  OBLIQUE: 'oblique',
});

const textDecorationOption = Object.freeze({
  NONE: 'none',
  UNDERLINE: 'underline',
});

const formatStyle = ([key, val]) => {
  switch (key) {
    case 'fontWeight':
      return { [key]: fontWeightOption[val] };
    case 'fontStyle':
      return { [key]: fontStyleOption[val] };
    case 'textDecoration':
      return { [key]: textDecorationOption[val] };
    case 'backgroundImage':
      return val.url ? { [key]: `url(${val.url})` } : null;
    default:
      return { [key]: val };
  }
};

const formatCommonStyle = ({ __typename, ...styles }) =>
  Object.entries(styles).reduce((acc, [key, val]) => {
    return !val
      ? acc
      : {
          ...acc,
          ...formatStyle([key, val]),
        };
  }, {});

const formatEntity = data => data && formatCommonStyle(data);

export default formatEntity;
